<template>
  <v-dialog
    v-model="dialogframeboton"
    persistent
    :fullscreen="componenteview != 1 && componenteview != 2 ? true : false"
    :width="componenteview == 1 || componenteview == 2 ? '1200px' : ''"
  >
    <v-card>
      <v-toolbar dark color="red-darken-4">
        <v-toolbar-title
          ><v-icon left>{{ iconodialogbtn }}</v-icon> {{ titledialogbtn }} -
          {{ infollaves.Contrato }} - {{ infollaves.Ref_1 }} -
          {{ infollaves.Document_ID }} - {{ infollaves.Primer_Nombre }}
          {{ infollaves.Segundo_Nombre }} {{ infollaves.Primer_Apellido }}
          {{ infollaves.Segundo_Apellido }}
        </v-toolbar-title>
        <v-toolbar-items>
          <v-btn class="d-none d-md-block" dark text @click="CerrarCombos()"
            >Cerrar</v-btn
          >
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <!--Replicación por Departamento - Ciudad/Municipio ¡-->
        <v-row v-if="componenteview == 2">
          <!--Departamento-->
          <v-col cols="12" sm="6" md="6">
            <v-autocomplete
              v-model="Departamento_ID"
              :items="ArrayDpto_ID"
              :item-title="
                (ArrayDpto_ID) =>
                  ArrayDpto_ID.DepartamentoId + '-' + ArrayDpto_ID.Nombre
              "
              item-value="DepartamentoId"
              color="primary"
              label="Departamento :"
              dense
              :rules="[(v) => !!v || 'Campo obligatorio']"
              :update:modelValue="ChangeDepto_ID()"
              readonly
            >
            </v-autocomplete>
          </v-col>
          <!--Ciudad-->
          <v-col cols="12" sm="6" md="6">
            <v-autocomplete
              v-model="Ciudad_ID"
              :items="ArrayCiudad_ID"
              :item-title="
                (ArrayCiudad_ID) =>
                  ArrayCiudad_ID.CiudadId + '-' + ArrayCiudad_ID.Nombre
              "
              item-value="CiudadId"
              color="primary"
              label="Ciudad:"
              dense
              clearable
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-btn size="x-large" color="green" text @click="Replicacion(2)">
              Replicar
            </v-btn>
          </v-col>
        </v-row>
        <!-- Clientes ¡-->
        <card-clientes
          v-else-if="componenteview == 3"
          v-bind:pageiframe="dialogframeboton"
          v-on:update:pageiframe="dialogframeboton = $event"
          :infollaves="llaves"
          :infopermisos="'0010'"
        ></card-clientes>
        <!-- Consulta  Contratos ¡-->
        <card-contratos
          v-else-if="componenteview == 4"
          v-bind:pageiframe="dialogframeboton"
          v-on:update:pageiframe="dialogframeboton = $event"
          :infollaves="llaves"
          :infopermisos="'0010'"
        ></card-contratos>
        <!-- Consulta  Activos ¡-->
        <card-activos
          v-else-if="componenteview == 5"
          v-bind:pageiframe="dialogframeboton"
          v-on:update:pageiframe="dialogframeboton = $event"
          :infollaves="llaves"
          :infopermisos="'0010'"
        ></card-activos>
        <!-- Consulta  Seguros ¡-->
        <card-seguros
          v-else-if="componenteview == 6"
          v-bind:pageiframe="dialogframeboton"
          v-on:update:pageiframe="dialogframeboton = $event"
          :infollaves="llaves"
          :infopermisos="'0110'"
          :TipoSeguro="TipoSeguro"
        ></card-seguros>
        <!-- Documentos -->
        <card-documentos
          v-else-if="componenteview == 7"
          :infollaves="llaves"
        ></card-documentos>
        <!-- Consulta Documentos ¡-->
        <card-consultadocumentos
          v-else-if="componenteview == 8"
          :infollaves="llaves"
        ></card-consultadocumentos>
        <!-- Vigencias en Mora ¡-->
        <card-vigencias
          v-else-if="componenteview == 10"
          :infollaves="llaves"
        ></card-vigencias>
      </v-card-text>
    </v-card>
  </v-dialog>
  <!-- Tablero de control -->
  <v-data-table
    v-model="selected"
    v-model:page="itemsPerPage"
    :headers="headers"
    :items="desserts"
    :search="search"
    item-value="Soporte_ID"
    show-select
    return-object
    height="550px"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <!-- Campos -->
        <v-dialog v-model="dialogframecreate" persistent max-width="1500px">
          <template v-if="param1[1] == '1'" v-slot:activator="{ props }">
            <v-btn
              color="green"
              icon="mdi-plus"
              size="x-large"
              dark
              class="mb-2"
              @click="
                editedItem = null;
                editedIndex = -1;
                dialogframecreate = true;
              "
              v-bind="props"
            >
            </v-btn>
          </template>
          <v-card>
            <v-toolbar dark color="red-darken-4">
              <v-toolbar-title
                ><v-icon left>{{ iconTitle }}</v-icon> {{ formTitle }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  class="d-none d-md-block"
                  dark
                  text
                  @click="
                    dialogframecreate = false;
                    editedItem = null;
                    editedIndex = -1;
                  "
                  >Cerrar</v-btn
                >
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <proceso-registro
                v-if="dialogframecreate"
                :infoedit="editedItem"
                v-bind:page="dialogframecreate"
                v-on:update:page="dialogframecreate = $event"
                v-bind:Exito="respuestapostput"
                v-on:update:Exito="respuestapostput = $event"
                v-bind:componenteview="componenteview"
                v-on:update:componenteview="componenteview = $event"
                v-bind:pageiframe="dialogframeboton"
                v-on:update:pageiframe="dialogframeboton = $event"
                v-bind:titledialogbtn="titledialogbtn"
                v-on:update:titledialogbtn="titledialogbtn = $event"
                v-bind:iconodialogbtn="iconodialogbtn"
                v-on:update:iconodialogbtn="iconodialogbtn = $event"
                v-bind:llavesiframe="llaves"
                v-on:update:llavesiframe="llaves = $event"
                :infopermisos="infopermisos"
                :editedIndex="editedIndex"
                :infollaves="infollaves"
              ></proceso-registro>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-divider
          v-if="param1[1] == '1'"
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <!-- Eliminación -->
        <v-btn
          v-if="param1[3] == '1'"
          color="red"
          icon="mdi-delete"
          dark
          class="mb-2"
          @click="Eliminar"
        >
        </v-btn>
        <v-divider
          v-if="param1[3] == '1'"
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <!-- Filtros -->
        <v-dialog v-model="dialogframe" persistent max-width="1000px">
          <template v-slot:activator="{ props }">
            <v-btn
              color="cyan"
              icon="mdi-filter-menu"
              dark
              class="mb-2"
              v-bind="props"
              @click="CargueCombo"
            >
            </v-btn>
          </template>
          <v-card>
            <v-toolbar dark color="red-darken-4">
              <v-toolbar-title
                ><v-icon left>mdi-filter-menu</v-icon> Filtros
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn class="d-none d-md-block" dark text @click="reset"
                  >Limpiar</v-btn
                >
                <v-btn
                  class="d-none d-md-block"
                  dark
                  text
                  @click="ValidateCampos"
                  >Consultar</v-btn
                >
                <v-btn
                  class="d-none d-md-block"
                  dark
                  text
                  @click="dialogframe = false"
                  >Cerrar</v-btn
                >
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-form ref="form" autocomplete="off">
                <v-row v-for="(datos, i) in modelfiltro" :key="i">
                  <!-- Filtro -->
                  <v-col cols="6">
                    <v-autocomplete
                      v-model="datos.filtro"
                      :items="items"
                      item-title="descripcion"
                      item-value="filtro"
                      label="Tipo de filtro:"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    ></v-autocomplete>
                  </v-col>
                  <!-- Contenido -->
                  <v-col v-if="i == 2" cols="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayEstado"
                      :item-title="
                        (ArrayEstado) =>
                          ArrayEstado.EstadoID + '-' + ArrayEstado.Descripcion
                      "
                      item-value="EstadoID"
                      :label="datos.label"
                      dense
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col v-else-if="i == 3" cols="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayTipoObservacion"
                      :item-title="
                        (ArrayTipoObservacion) =>
                          ArrayTipoObservacion.TipoObservacion +
                          '-' +
                          ArrayTipoObservacion.DescTipoObservacion
                      "
                      item-value="TipoObservacion"
                      :label="datos.label"
                      dense
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col v-else-if="i == 4" cols="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayRevision"
                      :item-title="
                        (ArrayRevision) =>
                          ArrayRevision.Valor + '-' + ArrayRevision.Descripcion
                      "
                      item-value="Valor"
                      :label="datos.label"
                      dense
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col v-else cols="6">
                    <v-text-field
                      v-model="datos.contenido"
                      :label="datos.label"
                      :type="i == 7 || i == 6 ? 'date' : ''"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <!-- Buscador -->
        <v-text-field
          v-model="search"
          append-inner-icon="mdi-magnify"
          label="Buscar..."
          single-line
          variant="underlined"
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="text-center">
        <v-menu
          v-model="menubuttoms[item.raw.Soporte_ID]"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x
        >
          <template v-slot:activator="{ props }">
            <v-icon color="red-darken-4" v-bind="props">
              mdi-file-settings</v-icon
            >
          </template>
          <v-card flat>
            <v-card-text>
              <v-container>
                <v-row>
                  <!-- Modificación  -->
                  <v-tooltip
                    v-if="param1[2] == '1' || param1[0] == '1'"
                    location="bottom"
                    color="white"
                  >
                    <template v-slot:activator="{ props }">
                      <v-icon
                        color="#05AD58"
                        @click="editItem(item.raw, 0)"
                        v-bind="props"
                        >{{
                          param1[2] == "1" && param1[0] == "0"
                            ? "mdi-pencil"
                            : "mdi-eye"
                        }}</v-icon
                      >
                    </template>
                    <span>{{
                      param1[2] == "1" && param1[0] == "0"
                        ? "Modificar"
                        : "Consultar"
                    }}</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Replicar Contrato/Activo -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 1)"
                        color="blue"
                        v-bind="props"
                        >mdi-reply-all-outline</v-icon
                      >
                    </template>
                    <span>Replicar por Contrato/Activo</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Replicar Ciudad/Municipio -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 2)"
                        color="orange"
                        v-bind="props"
                        >mdi-map-marker-distance</v-icon
                      >
                    </template>
                    <span>Replicación por Departamento - Ciudad/Municipio</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Replicar por EPS -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 9)"
                        color="yellow"
                        v-bind="props"
                        >mdi-home-switch-outline</v-icon
                      >
                    </template>
                    <span>Replicación por EPS</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Cliente -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 3)"
                        color="cyan"
                        v-bind="props"
                        >mdi-account</v-icon
                      >
                    </template>
                    <span>Clientes</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Contratos -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 4)"
                        color="red"
                        v-bind="props"
                        >mdi-note</v-icon
                      >
                    </template>
                    <span>Contratos</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Activos -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 5)"
                        color="cyan"
                        v-bind="props"
                        >mdi-home-group</v-icon
                      >
                    </template>
                    <span>Activos</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Seguros -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 6)"
                        color="cyan"
                        v-bind="props"
                        >mdi-account-lock</v-icon
                      >
                    </template>
                    <span>Seguros</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Anexar Documento -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 7)"
                        color="indigo"
                        v-bind="props"
                        >mdi-folder-open</v-icon
                      >
                    </template>
                    <span>Anexar Documento</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Consultar Documento -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 8)"
                        color="purple"
                        v-bind="props"
                        >mdi-file-search</v-icon
                      >
                    </template>
                    <span>Consulta documentos</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Consultar Documento -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 10)"
                        color="red"
                        v-bind="props"
                        >mdi-timer-alert</v-icon
                      >
                    </template>
                    <span>Vigencias en Mora</span>
                  </v-tooltip>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-menu>
      </div>
    </template>
  </v-data-table>
  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Registro from "@/views/TCI/ActivosO/HistoricoSoportes/HistoricoSoportesRegistro.vue";
import Activos from "@/views/TCI/ActivosO/Activos/Activos.vue";
import Contrato from "@/views/TCI/ActivosO/Contratos/Contratos.vue";
import Seguros from "@/views/TCI/ActivosO/Seguros/Seguros.vue";
import Clientes from "@/views/TCI/Personas/Clientes/Clientes.vue";
import DocumentosComponents from "@/views/TCI/Documentos/DocumentosComponents/DocumentosComponentsActivos.vue";
import ConsultaDocumentos from "@/views/TCI/Documentos/ConsultaDocumentos/ConsultaDocumentos.vue";
import Vigencias from "@/views/TCI/ActivosO/VigenciasMora/VigenciasMoraRegistro.vue";
export default {
  name: "HistoricoSoportes",
  props: {
    infollaves: {
      type: Object,
      default: [],
      Description: "Información de llaves",
    },
    arraydatos: {
      type: Object,
      default: null,
      Description: "Devuelve Array con registro actualizado",
    },
    posicionArray: {
      type: Number,
      default: 0,
      Description: "Devuelve Posición de array con registro actualizado",
    },
    infopermisos: {
      type: String,
      default: "0111",
      Description: "Información de permisos",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
  },
  components: {
    "proceso-registro": Registro,
    "card-clientes": Clientes,
    "card-contratos": Contrato,
    "card-activos": Activos,
    "card-seguros": Seguros,
    "card-consultadocumentos": ConsultaDocumentos,
    "card-documentos": DocumentosComponents,
    "card-vigencias": Vigencias,
  },
  data() {
    return {
      TipoSeguro: null,
      itemsPerPage: 1,
      selected: [],
      search: "",
      respuestapostput: "",
      consult: false,
      editedItem: null,
      editedIndex: -1,
      progreso: false,
      dialogframe: false,
      dialogframecreate: false,
      dialogframeboton: false,
      iconodialogbtn: "",
      titledialogbtn: "",
      componenteview: 0,
      menubuttoms: [],
      infoitem: [],
      items: [
        {
          filtro: "=",
          descripcion: "Igual a",
        },
        {
          filtro: "LIKE",
          descripcion: "Similar a",
        },
        {
          filtro: ">=",
          descripcion: "Mayor igual a",
        },
        {
          filtro: "<=",
          descripcion: "Menor igual a",
        },
      ],
      modelfiltro: [
        {
          campo: "Ref1",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Activo:",
        },
        {
          campo: "ServicioID",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Servicio:",
        },
        {
          campo: "EstadoRevision",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Estado:",
        },
        {
          campo: "TipoObservacion",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Tipo de observación:",
        },
        {
          campo: "MedioRevision",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Medio Revisión:",
        },
        {
          campo: "UsuarioRevision",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Usuario revisión:",
        },
        {
          campo: "FechaRevision",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Fecha Revisión:",
        },
        {
          campo: "InicioMora",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Fecha Mora:",
        },
        {
          campo: "DiasMoraFechaValidacion",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Dias mora:",
        },
        {
          campo: "ValorMora",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Valor Mora:",
        },
      ],
      headers: [],
      llaves: {
        TypeDocument_ID: null,
        Document_ID: null,
        Primer_Apellido: null,
        Segundo_Apellido: null,
        Primer_Nombre: null,
        Segundo_Nombre: null,
        Solicitud: null,
        Contrato: null,
        Ref_1: null,
        Ref_2: null,
        Ref_3: null,
        IDServicio: null,
        IDPoliza: null,
        Secuencia_ID: null,
      },
      desserts: [],
      ArrayEstado: [],
      ArrayRevision: [],
      ArrayTipoObservacion: [],
      ArrayDpto_ID: [],
      ArrayCiudad_ID: [],
      Departamento_ID: null,
      Ciudad_ID: null,
      param1: [],
      busquedacompleta: false,
      wdpto: null,
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Crear Registro"
        : this.param1[2] == "1" && this.param1[0] == "0"
          ? "Actualizar registro"
          : "Consultar registro";
    },
    iconTitle() {
      return this.editedIndex === -1
        ? "mdi-plus"
        : this.param1[2] == "1" && this.param1[0] == "0"
          ? "mdi-pencil"
          : "mdi-eye";
    },
  },
  watch: {
    dialogframecreate(val) {
      if (!val && this.respuestapostput == "Exito" && this.consult) {
        this.respuestapostput = null;
        this.ValidateCampos();
        this.itemsPerPage = 1;
      }
    },
  },
  methods: {
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      this.consult = validate;
      this.busquedacompleta = false;
      for (var i = 0; i < this.modelfiltro.length; i++) {
        if (
          (this.modelfiltro[i].filtro == "" ||
            this.modelfiltro[i].filtro == null) &&
          this.modelfiltro[i].contenido != "" &&
          this.modelfiltro[i].contenido != null
        ) {
          validate = true;
        } else if (
          (this.modelfiltro[i].contenido == "" ||
            this.modelfiltro[i].contenido == null) &&
          this.modelfiltro[i].filtro != "" &&
          this.modelfiltro[i].filtro != null
        ) {
          validate = true;
        } else if (
          (this.modelfiltro[i].contenido != "" ||
            this.modelfiltro[i].contenido != null) &&
          this.modelfiltro[i].filtro != "" &&
          this.modelfiltro[i].filtro != null
        ) {
          this.busquedacompleta = true;
        }
        // Convertir a string
        if (
          this.modelfiltro[i].contenido != "" &&
          this.modelfiltro[i].contenido != null
        ) {
          this.modelfiltro[i].contenido = String(this.modelfiltro[i].contenido);
        }
      }

      // Consultas a Ejecutar
      if (!validate) {
        this.consult = true;
        this.getConsultData();
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos o no contiene el respecitivo filtro.",
        });
      }
    },
    // Consulta Tablero
    async getConsultData() {
      this.desserts = [];
      this.selected = [];
      this.progreso = true;
      var ArrayServices = this.$store.getters.MServicio.filter(
        (item) => item.ServicioID == this.infollaves.IDServicio,
      );
      var TipoServicio = ArrayServices[0].TipoServicio;
      var data = {
        busquedacompleta: this.busquedacompleta,
        parametro1: null,
        filtrado: this.modelfiltro,
        parametro2: TipoServicio.toString(),
      };
      this.axios
        .post("/ActivosO/HistoricoSoportes/CT0/", data)
        .then((result) => {
          this.desserts = result.data;
          this.CabeceraConsulta();
        })
        .catch((error) => {
          console.log(error);
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
          this.dialogframe = false;
        });
    },
    CabeceraConsulta() {
      var TipoServicio = null;
      var ArrayServices = this.$store.getters.MServicio.filter(
        (item) => item.ServicioID == this.infollaves.IDServicio,
      );
      TipoServicio = ArrayServices[0].TipoServicio;

      if (TipoServicio == 6) {
        this.headers = [
          {
            title: "Acciones",
            key: "actions",
            align: "center",
            sortable: false,
          },
          {
            title: "Estado",
            key: "DescEstadoRevision",
            width: "300px",
          },
          {
            title: "Medio de revisión",
            key: "DescMedioRevision",
            width: "300px",
          },
          {
            title: "Poliza",
            key: "Poliza",
            align: "center",
          },
          {
            title: "Anexo",
            key: "Anexo",
            align: "center",
          },
          {
            title: "Tipo de poliza",
            key: "DescTipoPoliza",
            align: "center",
            width: "150px",
          },
          {
            title: "Clase de póliza",
            key: "DescClasePoliza",
            align: "center",
          },
          {
            title: "Fecha Inicial",
            key: "FechaInicial",
            align: "center",
            width: "150px",
          },
          {
            title: "Fecha Final",
            key: "FechaFinal",
            align: "center",
            width: "150px",
          },
          {
            title: "Valor Asegurado",
            key: "ValorAsegurado",
            align: "center",
          },
          {
            title: "Usuario revisión",
            key: "UsuarioRevision",
            align: "center",
          },
          {
            title: "Fecha de revisión",
            key: "FechaRevision",
            align: "center",
            width: "150px",
          },
          {
            title: "Hora de revisión",
            key: "HoraRevision",
            align: "center",
          },
        ];
      } else {
        this.headers = [
          {
            title: "Acciones",
            key: "actions",
            align: "center",
            sortable: false,
          },
          {
            title: "Estado",
            key: "DescEstadoRevision",
            width: "300px",
          },
          {
            title: "Medio de revisión",
            key: "DescMedioRevision",
            width: "300px",
          },
          {
            title: "Inicio Corte de Soporte",
            key: "InicioPagoOportuno",
            align: "center",
          },
          {
            title: "Fin Corte de Soporte",
            key: "PagoOportuno",
            align: "center",
          },
          {
            title: "Valor Factura",
            key: "ValorFactura",
            align: "center",
          },
          {
            title: "Valor Descuento",
            key: "ValorOtros",
            align: "center",
          },
          {
            title: "Fecha Mora",
            key: "InicioMora",
            align: "center",
          },
          {
            title: "Dias en mora fecha validación",
            key: "DiasMoraFechaValidacion",
            align: "center",
          },
          {
            title: "ValorMora",
            key: "ValorMora",
            align: "center",
          },
          {
            title: "Usuario revisión",
            key: "UsuarioRevision",
            align: "center",
          },
          {
            title: "Fecha de revisión",
            key: "FechaRevision",
            align: "center",
          },
        ];
      }
    },
    // Item editar
    editItem(item, iconoelegido) {
      this.componenteview = iconoelegido;
      this.infoitem = item;

      switch (iconoelegido) {
        case 0:
          this.editedIndex = this.desserts.indexOf(item);
          this.editedItem = Object.assign({}, item);
          this.dialogframecreate = true;
          break;
        case 1: // Replicar por Contrato/Activo
          this.Replicacion(1);
          break;
        case 2: //Replicación por Departamento - Ciudad/Municipio
          this.iconodialogbtn = "mdi-map-marker-distance";
          this.titledialogbtn =
            "Replicación por Departamento - Ciudad/Municipio";
          this.dialogframeboton = true;
          this.ChangePais_ID();
          break;
        case 3: //Clientes
          this.iconodialogbtn = "mdi-account";
          this.titledialogbtn = "Clientes";
          this.dialogframeboton = true;
          this.llaves.TypeDocument_ID = this.infollaves.TypeDocument_ID;
          this.llaves.Document_ID = this.infollaves.Document_ID;
          break;
        case 4: //Contratos
          this.iconodialogbtn = "mdi-note";
          this.titledialogbtn = "Contratos";
          this.dialogframeboton = true;
          this.llaves.Contrato = this.infollaves.Contrato;
          break;
        case 5: //Activos
          this.iconodialogbtn = "mdi-home-group";
          this.titledialogbtn = "Activos";
          this.dialogframeboton = true;
          this.llaves.Ref_1 = this.infollaves.Ref_1;
          break;
        case 6: //Seguros
          this.iconodialogbtn = "mdi-folder-open";
          this.titledialogbtn = "Seguros";
          this.dialogframeboton = true;
          this.llaves.TypeDocument_ID = this.infollaves.TypeDocument_ID;
          this.llaves.Document_ID = this.infollaves.Document_ID;
          this.llaves.Contrato = this.infollaves.Contrato;
          this.llaves.Ref_1 = this.infollaves.Ref_1;
          break;
        case 7: //Documentos
          this.iconodialogbtn = "mdi-file-search";
          this.titledialogbtn = "Anexar Documentos";
          this.dialogframeboton = true;
          this.llaves.TypeDocument_ID = this.infollaves.TypeDocument_ID;
          this.llaves.Document_ID = this.infollaves.Document_ID;
          this.llaves.Contrato = this.infollaves.Contrato;
          this.llaves.Ref_1 = this.infollaves.Ref_1;
          this.llaves.IDServicio = this.infollaves.IDServicio;
          this.llaves.Secuencia_ID = item.Soporte_ID;
          break;
        case 8: //Consulta Documentos
          this.iconodialogbtn = "mdi-note";
          this.titledialogbtn = "Consulta de documentos";
          this.dialogframeboton = true;
          this.llaves.TypeDocument_ID = this.infollaves.TypeDocument_ID;
          this.llaves.Document_ID = this.infollaves.Document_ID;
          this.llaves.Contrato = this.infollaves.Contrato;
          this.llaves.Ref_1 = item.Ref_1;
          this.llaves.IDServicio = this.infollaves.IDServicio;
          this.llaves.Secuencia_ID = item.Soporte_ID;
          break;
        case 9: // Replicar EPS
          this.Replicacion(3);
          break;
        case 10: //Vigencias en Mora
          this.iconodialogbtn = "mdi-timer-alert";
          this.titledialogbtn = "Vigencias en Mora";
          this.dialogframeboton = true;
          this.llaves.TypeDocument_ID = this.infollaves.TypeDocument_ID;
          this.llaves.Document_ID = this.infollaves.Document_ID;
          this.llaves.Contrato = this.infollaves.Contrato;
          this.llaves.Ref_1 = this.infollaves.Ref_1;
          this.llaves.IDServicio = this.infollaves.IDServicio;
          this.llaves.Secuencia_ID = item.Soporte_ID;
          break;
      }
    },
    // Confirmación de eliminación
    Eliminar() {
      if (this.selected.length != 0 && this.selected != null) {
        this.$swal({
          icon: "question",
          title: "Eliminar Información",
          html: "¿Está seguro que desea eliminar la información seleccionada?<br>Esta acción no se puede deshacer luego de confirmarla.",
          confirmButtonText: "Sí",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.isConfirmed) {
            this.getDelete();
          }
        });
      } else {
        this.$swal({
          icon: "info",
          title: "Seleccione la fila a eliminar",
          html: "Lo sentimos, debe seleccionar la celda o celdas para eliminar el registro.",
        });
      }
    },

    // Eliminación de registros
    async getDelete() {
      this.progreso = true;
      this.axios
        .put("/ActivosO/HistoricoSoportes/ModificacionEstado/", this.selected)
        .then((response) => {
          if (response.data === "Exito") {
            this.$swal({
              icon: "success",
              title: "Información Eliminada",
              html: "La información se ha eliminado correctamente.",
            });
            this.getConsultData();
            this.selected = [];
          } else {
            this.$swal({
              icon: "error",
              title: "Error al guardar los datos",
              html: response.data.toString(),
            });
          }
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    // Confirmación de Replicación
    Replicacion(idreplicacion) {
      var mensaje =
        idreplicacion == 1
          ? "Masivo Contrato Activo"
          : idreplicacion == 2
            ? "Masivo Departamento - Ciudad"
            : "Masivo EPS";

      this.$swal({
        icon: "question",
        title: "Replicar Información " + mensaje,
        html: "¿Está seguro que desea replicar la información seleccionada?<br>Esta acción no se puede deshacer luego de confirmarla.",
        confirmButtonText: "Sí",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.isConfirmed && idreplicacion == 1) {
          this.postReplicacion();
        } else if (result.isConfirmed && idreplicacion == 2) {
          this.postReplicacionMasivoDptoCity();
        } else if (result.isConfirmed && idreplicacion == 3) {
          this.postReplicacionMasivoEps();
        }
      });
    },
    // Replicar Soporte - Relación Contrato Activo
    async postReplicacion() {
      var userperfil = this.$store.getters.userperfil;
      this.infoitem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
      this.infoitem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;
      this.infoitem.UsuarioRevision = userperfil.userInfo.Usuario_ID;
      // Data
      var data = {
        historicoSoportes: this.infoitem,
        informacionLlaves: this.infollaves,
      };

      this.progreso = true;
      this.axios
        .post("/ActivosO/HistoricoSoportes/MasivoContrato/", data)
        .then((response) => {
          this.$swal({
            icon: "success",
            title: "Información Replicada",
            html: "La información se ha replicado correctamente, por favor revisar.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },

    // Replicar Soporte - Masivo Departamento Ciudad
    async postReplicacionMasivoDptoCity() {
      // Data
      this.infoitem.Departamento_IDMassive = this.Departamento_ID;
      this.infoitem.Ciudad_IDMassive = this.Ciudad_ID;
      var userperfil = this.$store.getters.userperfil;
      this.infoitem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
      this.infoitem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;
      this.infoitem.UsuarioRevision = userperfil.userInfo.Usuario_ID;
      var data = {
        historicoSoportes: this.infoitem,
        informacionLlaves: this.infollaves,
      };

      this.progreso = true;
      this.axios
        .post("/ActivosO/HistoricoSoportes/MasivoCiudadDepartamento/", data)
        .then((response) => {
          this.$swal({
            icon: "success",
            title: "Información Replicada",
            html: "La información se ha replicado correctamente, por favor revisar.",
          });
          this.Ciudad_ID = null;
          this.CerrarCombos();
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },

    // Replicar Soporte - Masivo Eps
    async postReplicacionMasivoEps() {
      // Data
      var userperfil = this.$store.getters.userperfil;
      this.infoitem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
      this.infoitem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;
      this.infoitem.UsuarioRevision = userperfil.userInfo.Usuario_ID;
      var data = {
        historicoSoportes: this.infoitem,
        informacionLlaves: this.infollaves,
      };

      this.progreso = true;
      this.axios
        .post("/ActivosO/HistoricoSoportes/MasivoEPS/", data)
        .then((response) => {
          this.$swal({
            icon: "success",
            title: "Información Replicada",
            html: "La información se ha replicado correctamente, por favor revisar.",
          });
        })
        .catch((error) => {
          console.log(error);
          const registro = error.response.data;
          const mensajeerror = error.response.data;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror.Message,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    /////////////////////////////////////////////// Métodos Changes ///////////////////////////////////////////////
    // Función de gestion cambio
    ChangePais_ID() {
      this.ArrayDpto_ID = [];
      this.Departamento_ID = null;
      this.getDpto_ID();
    },
    // Get para obtener array de los departamento existentes
    getDpto_ID() {
      this.ArrayDpto_ID = [];
      var ArrayDpto_ID2 = this.$store.getters.MDpto;
      this.ArrayDpto_ID = ArrayDpto_ID2.filter(
        (item) => item.departamentoId != 0,
      );
      if (
        this.infollaves.Departamento != null &&
        this.infollaves.Departamento != 0
      ) {
        this.Departamento_ID = this.infollaves.Departamento;
      }
    },
    // Función de gestion cambio
    ChangeDepto_ID() {
      if (this.wdpto != this.Departamento_ID) {
        this.wdpto = this.Departamento_ID;
        if (this.Departamento_ID == "" || this.Departamento_ID == null) {
          this.ArrayCiudad_ID = [];
          this.Ciudad_ID = null;
        } else {
          this.getCiudad_ID();
        }
      }
    },
    // Get para obtener array de las ciudades existentes
    getCiudad_ID() {
      if (this.Departamento_ID != "" && this.Departamento_ID != null) {
        this.ArrayCiudad_ID = [];
        var Dpto = this.Departamento_ID;
        var ArrayCiudad_ID2 = this.$store.getters.MCity;
        this.ArrayCiudad_ID = ArrayCiudad_ID2.filter(
          (item) => item.CiudadId != 0 && item.DepartamentoId == Dpto,
        );

        if (this.infollaves.Ciudad != null && this.infollaves.Ciudad != 0) {
          this.Ciudad_ID = this.infollaves.Ciudad;
        }
      }
    },
    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    // Cerrar combos
    CerrarCombos() {
      this.dialogframeboton = false;
      this.llaves.TypeDocument_ID = null;
      this.llaves.Document_ID = null;
      this.llaves.Primer_Apellido = null;
      this.llaves.Primer_Nombre = null;
      this.llaves.Segundo_Nombre = null;
      this.llaves.Solicitud = null;
      this.llaves.Contrato = null;
      this.llaves.Ref_1 = null;
      this.llaves.Ref_2 = null;
      this.llaves.Ref_3 = null;
      this.llaves.IDServicio = null;
      this.llaves.IDPoliza = null;
    },
    // Limpiar campos
    reset() {
      this.busquedacompleta = false;
      this.$refs.form.reset();
      if (this.pageiframe) {
        if (this.infollaves.Ref_1 != null && this.infollaves.Ref_1 != "") {
          this.modelfiltro[0].contenido = this.infollaves.Ref_1;
          this.modelfiltro[0].lectura = true;
          this.modelfiltro[0].clear = false;
          this.modelfiltro[0].filtro = "=";
        }
        if (
          this.infollaves.IDServicio != null &&
          this.infollaves.IDServicio != ""
        ) {
          this.modelfiltro[1].contenido = this.infollaves.IDServicio;
          this.modelfiltro[1].lectura = true;
          this.modelfiltro[1].clear = false;
          this.modelfiltro[1].filtro = "=";
        }
      }
    },
    // Cargue Combo
    CargueCombo() {
      this.ArrayEstado = this.$store.getters.MREstadoServicio.filter(
        (item) => item.ServicioID == this.infollaves.IDServicio,
      );

      this.ArrayRevision = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 55,
      );

      var TipoObservacion = this.$store.getters.MRObservacionServicio;
      this.ArrayTipoObservacion = TipoObservacion.filter(
        (item) => item.ServicioID == this.infollaves.IDServicio,
      );
    },
    // Busca los parametros de la pagina
    parametrospaginas() {
      var page = this.$store.getters.userperfil.paginainfo;
      if (page.param1) {
        var splitparam1 = page.param1.split("");
        this.param1 = splitparam1;
      }
    },
    // Parametros Iframe
    parametrosiframe() {
      if (this.infollaves.Ref_1 != null && this.infollaves.Ref_1 != "") {
        this.modelfiltro[0].contenido = this.infollaves.Ref_1;
        this.modelfiltro[0].lectura = true;
        this.modelfiltro[0].clear = false;
        this.modelfiltro[0].filtro = "=";
      }
      if (
        this.infollaves.IDServicio != null &&
        this.infollaves.IDServicio != ""
      ) {
        this.modelfiltro[1].contenido = this.infollaves.IDServicio;
        this.modelfiltro[1].lectura = true;
        this.modelfiltro[1].clear = false;
        this.modelfiltro[1].filtro = "=";
        // Tipo de seguro
        var ArrayServices = this.$store.getters.MServicio.filter(
          (item) => item.ServicioID == this.infollaves.IDServicio,
        );
        this.TipoSeguro = ArrayServices[0].TipoSeguro;
      }
      var splitparam1 = this.infopermisos.split("");
      this.param1 = splitparam1;
      this.ValidateCampos();
    },
  },
  mounted() {
    if (!this.pageiframe) {
      this.parametrospaginas();
    } else {
      this.parametrosiframe();
    }
  },
};
</script>
